import { render, staticRenderFns } from "./TaxCalculatorNew.vue?vue&type=template&id=c7edf66e&scoped=true"
import script from "./TaxCalculatorNew.vue?vue&type=script&lang=js"
export * from "./TaxCalculatorNew.vue?vue&type=script&lang=js"
import style0 from "./TaxCalculatorNew.vue?vue&type=style&index=0&id=c7edf66e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7edf66e",
  null
  
)

export default component.exports